/**
 * CardGrid.jsx
 *
 * Affiche une grille de cartes responsive
 * Utilise Ant Design Grid
 */

import React from "react";
import { Row, Col, Empty } from "antd";
import CardItem from "./CardItem";

/**
 * CardGrid - Grille responsive de cartes
 * @param {Array} cards - Tableau de cartes à afficher
 */
export default function CardGrid({ cards }) {
    if (!cards || cards.length === 0) {
        return <Empty description="Aucune carte trouvée" style={{ margin: "48px 0" }} />;
    }

    return (
        <Row gutter={[16, 16]} style={{ padding: "16px" }}>
            {cards.map((card) => (
                <Col key={card.id} xs={12} sm={12} md={8} lg={6} xl={6}>
                    <CardItem card={card} />
                </Col>
            ))}
        </Row>
    );
}